import axios from "axios";
import { geofenceActionTypes } from "./geofenceTypes";
import baseUrl from "../../config/api";

//create geofence actions
export const setActiveGeofence = (geofence) => ({
  type: geofenceActionTypes.SET_ACTIVE_GEOFENCE,
  payload: geofence,
});

export const saveGeofenceStart = () => ({
  type: geofenceActionTypes.SAVE_GEOFENCE_START,
});

export const saveGeofenceSuccess = (geofence) => ({
  type: geofenceActionTypes.SAVE_GEOFENCE_SUCCESS,
  payload: geofence,
});

export const saveGeofenceFailure = (error) => ({
  type: geofenceActionTypes.SAVE_GEOFENCE_FAILURE,
  payload: error,
});

//get all geofences actions
export const getAllGeofencesStart = () => ({
  type: geofenceActionTypes.GET_ALL_GEOFENCES_START,
});

export const getAllGeofencesSuccess = (geofences) => ({
  type: geofenceActionTypes.GET_ALL_GEOFENCES_SUCCESS,
  payload: geofences,
});

export const getAllGeofencesFailure = (error) => ({
  type: geofenceActionTypes.GET_ALL_GEOFENCES_FAILURE,
  payload: error,
});

// Delete Geofence actions
export const deleteGeofenceStart = () => ({
  type: geofenceActionTypes.DELETE_GEOFENCE_START,
});

export const deleteGeofenceSuccess = (success, geofenceId) => ({
  type: geofenceActionTypes.DELETE_GEOFENCE_SUCCESS,
  payload: {
    success,
    geofenceId,
  },
});

export const deleteGeofenceFailure = (error) => ({
  type: geofenceActionTypes.DELETE_GEOFENCE_FAILURE,
  payload: error,
});

// Assign Devices to Geofence actions
export const assignGeofenceStart = () => ({
  type: geofenceActionTypes.ASSIGN_GEOFENCE_START,
});

export const assignGeofenceSuccess = (message) => ({
  type: geofenceActionTypes.ASSIGN_GEOFENCE_SUCCESS,
  payload: message,
});

export const assignGeofenceFailure = (error) => ({
  type: geofenceActionTypes.ASSIGN_GEOFENCE_FAILURE,
  payload: error,
});

// Un-assign Device from a Geofence actions
export const unassignGeofenceStart = () => ({
  type: "UNASSIGN_GEOFENCE_START",
});

export const unassignGeofenceSuccess = (data) => ({
  type: "UNASSIGN_GEOFENCE_SUCCESS",
  payload: data,
});

export const unassignGeofenceFailure = (error) => ({
  type: "UNASSIGN_GEOFENCE_FAILURE",
  payload: error,
});

//create geofence thunk
export const saveGeofence =
  (userId, geofenceData, token) => async (dispatch) => {
    dispatch(saveGeofenceStart());

    try {
      const response = await axios.post(
        `${baseUrl}/trackAPI/geofences/${userId}`,
        geofenceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response.data);
      dispatch(saveGeofenceSuccess(response.data));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to save geofence.";
      dispatch(saveGeofenceFailure(errorMsg));
    }
  };

//get all geofences thunk
export const getAllGeofences = (userId, token) => async (dispatch) => {
  dispatch(getAllGeofencesStart());

  try {
    const response = await axios.get(
      `${baseUrl}/trackAPI/geofences/${userId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch(getAllGeofencesSuccess(response.data));
  } catch (error) {
    const errorMsg =
      error.response?.data?.message || "Failed to fetch geofences.";
    dispatch(getAllGeofencesFailure(errorMsg));
  }
};

// Delete Geofence thunk
export const deleteGeofence =
  (userId, geofenceId, token) => async (dispatch) => {
    dispatch(deleteGeofenceStart());

    console.log(token);

    try {
      const response = await axios.delete(
        `${baseUrl}/trackAPI/geofences/${userId}/${geofenceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(deleteGeofenceSuccess(response.data, geofenceId));
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Failed to delete geofence.";
      dispatch(deleteGeofenceFailure(errorMsg));
    }
  };

// Assign Devices to Geofence thunk
export const assignGeofenceToDevices =
  (userId, geofenceId, devicesId, token) => async (dispatch) => {
    dispatch(assignGeofenceStart());

    try {
      const response = await axios.put(
        `${baseUrl}/trackAPI/geofences/${userId}/${geofenceId}/assignGeofence`,
        { devicesId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(assignGeofenceSuccess(response.data));
      dispatch({
        type: "SET_GEOFENCES_TO_DEVICE",
        payload: {
          devices: devicesId,
          geofence: geofenceId,
        },
      });
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Failed to assign geofence to devices.";
      dispatch(assignGeofenceFailure(errorMsg));
    }
  };

//

// Thunk for updating a specific geofence
export const updateGeofence =
  (userId, geofenceId, geofenceData, token) => async (dispatch) => {
    dispatch({ type: geofenceActionTypes.UPDATE_GEOFENCE_REQUEST });

    try {
      const response = await axios.put(
        `${baseUrl}/trackAPI/geofences/${userId}/${geofenceId}`,
        geofenceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: geofenceActionTypes.UPDATE_GEOFENCE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: geofenceActionTypes.UPDATE_GEOFENCE_FAILURE,
        payload: error.response ? error.response.data : error.message,
      });
    }
  };

// unassign geofence from device thunk
export const unassignGeofenceFromDevice =
  (userId, geofenceId, deviceId, token) => async (dispatch) => {
    dispatch(unassignGeofenceStart());

    try {
      const response = await axios.put(
        `${baseUrl}/trackAPI/geofences/${userId}/${geofenceId}/${deviceId}/unassignGeofence`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(unassignGeofenceSuccess(response.data));
      dispatch({
        type: "DELETE_GEOFENCES_FROM_DEVICE",
        payload: {
          device: deviceId,
          geofence: geofenceId,
        },
      });
    } catch (error) {
      const errorMsg =
        error.response?.data?.message ||
        "Failed to unassign geofence from device.";
      dispatch(unassignGeofenceFailure(errorMsg));
    }
  };
